import { useTheme, useMediaQuery } from "@material-ui/core";

interface CommonWitdhs {
	isXlUp: boolean;
	isLgUp: boolean;
	isSmDown: boolean;
	isXsDown: boolean;
	isBetweenXsAndSm: boolean;
}

const useCommonWidths = (): CommonWitdhs => {
	const theme = useTheme();

	const commonWitdhs = {
		isXlUp: useMediaQuery(theme.breakpoints.up("xl")),
		isLgUp: useMediaQuery(theme.breakpoints.up("lg")),
		isSmDown: useMediaQuery(theme.breakpoints.down("sm")),
		isXsDown: useMediaQuery(theme.breakpoints.down("xs")),
		isBetweenXsAndSm: useMediaQuery(theme.breakpoints.between("xs", "sm"))
	};

	return commonWitdhs;
};

export default useCommonWidths;
